import React, { useEffect, useRef, useState } from 'react'
import {
  DragDropContext,
  Droppable,
  DroppableProvided
} from 'react-beautiful-dnd'
import { TableColHeader } from './TableColHeader'
import styles from './TableHeader.module.scss'
import { TableHeaderProps } from './TableHeader.types'
import { additionalSubColumns, getGroupWidth } from './TableHeader.utils'

const TableHeaderComponent = (
  props: TableHeaderProps
) => {
  const {
    tableColumns,
    noFilters,
    dragDropContextProps,
    isByExpensesTabSelected,
    isExpandedBlobsColumn,
    isExpandedProductPagesColumn,
    isExpandedPostersColumn,
    isExpandedInteractionsColumn,
    isExpandedWatchTimeColumn,
    ...rest
  } = props

  const [containerWidth, setContainerWidth] = useState<number>(undefined)
  const ref = useRef<HTMLDivElement>()
  useEffect(() => {
    if (!ref.current) return
    setContainerWidth(ref.current.offsetWidth)
  }, [ref])

  return (
    <DragDropContext
      onDragEnd={dragDropContextProps?.onDragEnd}
      {...dragDropContextProps}
    >
      <Droppable droppableId='droppable' direction='horizontal'>
        {(provided: DroppableProvided) => {
          return (
            <div
              ref={el => {
                ref.current = el
                provided.innerRef(el)
              }}
              className={styles.tableHeader}
              {...rest}
              {...provided.droppableProps}
            >
              {additionalSubColumns(
                tableColumns,
                isByExpensesTabSelected,
                isExpandedBlobsColumn,
                isExpandedProductPagesColumn,
                isExpandedPostersColumn,
                isExpandedInteractionsColumn,
                isExpandedWatchTimeColumn).map((colProps, index) => {
                const {
                  groupWidth,
                  groupWidthPercentage,
                  ...col
                } = colProps
                return (
                  <TableColHeader
                    noFilter={noFilters}
                    key={index}
                    index={index}
                    groupWidth={
                      getGroupWidth(groupWidth, groupWidthPercentage, containerWidth)
                    }
                    {...col}
                  />
                )
              })}
              {provided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}

const TableHeader = TableHeaderComponent
export { TableHeader }
